import React, { useState } from "react";
import styles from "./Login.module.css";
import { loginUser } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import arrow from "../../images/arrow.svg";
import Polygon from "../../images/Polygon.svg";
import Elipse1 from "../../images/Elipse1.svg";
import Elipse2 from "../../images/Elipse2.svg";

export default function Login() {
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: null,
    password: null,
  });

  const navigate = useNavigate();

  const gotoRegister = () => {
    navigate("/register");
  };

  const gotoLanding = () => {
    navigate("/");
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    let isErrors = false;

    if (formValues.email.trim().length === 0) {
      setErrors((prev) => ({ ...prev, email: "invalid email" }));
      isErrors = true;
    } else {
      setErrors((prev) => ({ ...prev, email: null }));
    }

    if (formValues.password.trim().length === 0) {
      setErrors((prev) => ({ ...prev, password: "enter some value" }));
      isErrors = true;
    } else {
      setErrors((prev) => ({ ...prev, password: null }));
    }

    if (!isErrors) {
      try {
        const result = await loginUser(formValues);
        if (result) {
          navigate("/dashboard");
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };


  return (
    <div className={styles.login2}>
      <img className={styles.arrow} src={arrow} onClick={gotoLanding} alt="arrow" />
      <img className={styles.Polygon} src={Polygon} alt="Polygon" />
      <img className={styles.Elipse1} src={Elipse1} alt="Elipse1" />
      <img className={styles.Elipse2} src={Elipse2} alt="Elipse2" />
      <form onSubmit={handleSubmit}>
        <div>
          <label className={`${styles.label2} ${errors.email ? styles.errorLabel : ''}`} htmlFor="name">Email</label><br />
          <input
            type="email"
            className={`${styles.input2} ${errors.email ? styles.errorInput : ''}`}
            placeholder="Email"
            value={formValues.email}
            onChange={handleChange}
            name="email"
          />
          {errors.email && <div className={styles.eemail}>{errors.email}</div>}
        </div>
        <div>
          <label className={`${styles.label3} ${errors.password ? styles.errorLabel : ''}`} htmlFor="password">Password</label><br />
          <div>
            
            <input
              type="password"
              className={`${styles.input3} ${errors.password ? styles.errorInput : ''}`}
              placeholder="Password"
              value={formValues.password}
              onChange={handleChange}
              name="password"
            />
          </div>
          {errors.password && <div className={styles.epassword}>{errors.password}</div>}
        </div>
        <button className={styles.register} type="submit">Log In</button>
      </form>
      <p className={styles.haveacc}>Don’t have an account?<span className={styles.spanreg} onClick={gotoRegister}> Register now</span></p>
    </div>
  );
}
